import React from 'react';

const Loader = ({ isLoading }) => {
    // if (isLoading) {
        return (
            <div id='loading-bar-container'>
                <div id='loading-bar'>
                    <div className='sk-folding-cube' style={{ width: '100%' }}>
                        <div className='sk-cube1 sk-cube'></div>
                        <div className='sk-cube2 sk-cube'></div>
                        <div className='sk-cube4 sk-cube'></div>
                        <div className='sk-cube3 sk-cube'></div>
                    </div>
                </div>
            </div>
        );
    // }
    // return (<div id='loading-bar-container'></div>);
}


export default Loader;
